<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    id="Layer_1"
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
    style="enable-background: new 0 0 100 100"
    xml:space="preserve">
    <path
      d="M50,94.1C25.7,94.1,5.9,74.3,5.9,50S25.7,5.9,50,5.9c24.3,0,44.1,19.8,44.1,44.1C94.1,74.3,74.3,94.1,50,94.1z M50,0.5
  C22.7,0.5,0.5,22.7,0.5,50S22.7,99.5,50,99.5S99.5,77.3,99.5,50S77.3,0.5,50,0.5z" />
    <path
      d="M87.5,48.9L76.2,37.6c-0.6-0.6-1.5-0.6-2,0c-0.6,0.6-0.6,1.5,0,2l9,9H58.4c-0.7-4.1-4.2-7.2-8.4-7.2c-4.7,0-8.6,3.8-8.6,8.6
  s3.8,8.6,8.6,8.6c4.3,0,7.9-3.2,8.5-7.4h25l-9.3,9.3c-0.6,0.6-0.6,1.5,0,2c0.6,0.6,1.5,0.6,2,0l11.3-11.3c0.3-0.3,0.4-0.7,0.4-1.1
  C88,49.6,87.8,49.2,87.5,48.9z M50,55.8c-3.3,0-5.9-2.6-5.9-5.9c0-3.3,2.6-5.9,5.9-5.9s5.9,2.6,5.9,5.9C55.9,53.2,53.3,55.8,50,55.8
  z" />
  </svg>
</template>

<script type="text/babel">
  // import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

  export default {};
</script>
